<template>
  <v-icon :size="15" :color="iconColor">
    trip_origin
  </v-icon>
</template>

<script>
export default {
  name: "TubeColorIcon",

  props: {
    iconColor: String
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TubeColorIcon.vue